export default __webpack_public_path__ + "static/media/placeholder_dummy2016-heimtier01-de.a6fc5b21.png";